(() => {
  'use strict';
  const init = scope => {
    const roots = scope.matches?.('[data-lv-new-product]') ? [scope] : scope.querySelectorAll('[data-lv-new-product]');
    roots.forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-new-product-form]');
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const id = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      const submit = form.querySelector('[name="add"]');
      const status = root.querySelector('[data-status]');
      const sticky = root.querySelector('[data-sticky]');
      const stickyButton = root.querySelector('[data-sticky-add]');
      const currency = root.dataset.currency;
      const money = new Intl.NumberFormat('en-US', {style:'currency',currency,currencyDisplay:'narrowSymbol'});
      const format = amount => `${money.format(amount / 100)} ${currency}`;
      let busy = false;
      const selected = () => variants.find(variant => String(variant.id) === id.value) || variants[0];
      const update = (normalize = true) => {
        const variant = selected();
        const minimum = Math.max(1,Number(variant.minimum) || 1);
        const step = Math.max(1,Number(variant.step) || 1);
        const limits = [variant.maximum,variant.inventory].filter(n => n !== null && Number.isFinite(Number(n))).map(Number);
        const maximum = limits.length ? Math.min(...limits) : Infinity;
        quantity.min = minimum;
        quantity.step = step;
        if (Number.isFinite(maximum)) quantity.max = Math.max(0,maximum);
        else quantity.removeAttribute('max');
        let count = Number(quantity.value);
        if (normalize) {
          count = Number.isFinite(count) ? Math.max(minimum,Math.trunc(count)) : minimum;
          count = minimum + Math.floor((count - minimum) / step) * step;
          if (maximum >= minimum) count = Math.min(count,minimum + Math.floor((maximum - minimum) / step) * step);
          quantity.value = count;
        }
        const valid = Number.isInteger(count) && count >= minimum && count <= maximum && (count - minimum) % step === 0;
        root.querySelector('[data-price]').textContent = format(variant.price);
        root.querySelector('[data-sticky-price]').textContent = format(variant.price);
        root.querySelector('[data-total]').textContent = format(variant.price * (Number.isFinite(count) && count > 0 ? count : 0));
        const comparison = root.querySelector('[data-compare-price]');
        if (comparison) {
          comparison.hidden = !(variant.compare > variant.price);
          comparison.textContent = format(variant.compare || 0);
        }
        submit.disabled = busy || !variant.available || !valid;
        stickyButton.disabled = submit.disabled;
        const label = busy ? root.dataset.adding : !variant.available ? root.dataset.soldOut : root.dataset.addLabel;
        root.querySelector('[data-add-text]').textContent = label;
        stickyButton.textContent = label;
        root.querySelectorAll('[data-quantity-step]').forEach(button => {
          button.hidden = false;
          button.disabled = busy || !variant.available || (Number(button.dataset.quantityStep) < 0 ? count <= minimum : count + step > maximum);
        });
      };
      root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click',() => {
        quantity.value = (Number(quantity.value) || 1) + Number(button.dataset.quantityStep) * selected().step;
        status.textContent = '';
        update();
      }));
      quantity.addEventListener('input',() => update(false));
      quantity.addEventListener('change',() => update());
      id.addEventListener('change',() => {
        quantity.value = selected().minimum;
        const url = new URL(location.href);
        url.searchParams.set('variant',id.value);
        history.replaceState({},'',url);
        status.textContent = '';
        update();
      });
      const photos = [...root.querySelectorAll('[data-photo]')];
      const thumbs = [...root.querySelectorAll('[data-thumb]')];
      let current = 0;
      const show = index => {
        current = (index + photos.length) % photos.length;
        photos.forEach((photo,i) => { photo.hidden = i !== current; });
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed',String(i === current)));
        const image = photos[current].querySelector('img');
        if (image) image.loading = 'eager';
        root.querySelector('[data-gallery-counter]').textContent = `${current + 1} / ${photos.length}`;
        thumbs[current].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      };
      root.querySelectorAll('[data-gallery-controls]').forEach(control => {control.hidden = false;});
      thumbs.forEach(button => button.addEventListener('click',() => show(Number(button.dataset.thumb))));
      root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click',() => show(current + Number(button.dataset.galleryStep))));
      root.querySelector('[data-gallery]').addEventListener('keydown',event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        show(current + (event.key === 'ArrowLeft' ? -1 : 1));
      });
      let startX = null;
      root.querySelector('.lv-new-stage').addEventListener('touchstart',event => {startX = event.changedTouches[0].clientX;},{passive:true});
      root.querySelector('.lv-new-stage').addEventListener('touchend',event => {
        if (startX === null) return;
        const delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 50) show(current + (delta < 0 ? 1 : -1));
        startX = null;
      },{passive:true});
      form.addEventListener('submit',async event => {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (busy) return;
        update();
        if (submit.disabled || !form.reportValidity()) return;
        const data = new FormData(form);
        busy = true;
        status.textContent = '';
        form.setAttribute('aria-busy','true');
        update(false);
        try {
          const response = await fetch(root.dataset.addUrl,{method:'POST',body:data,headers:{Accept:'application/json'},credentials:'same-origin'});
          if (!response.ok) {
            status.textContent = response.status === 422 ? root.dataset.stockError : root.dataset.error;
            form.scrollIntoView({block:'center',behavior:'instant'});
            return;
          }
          location.assign(root.dataset.cartUrl);
        } catch {
          status.textContent = root.dataset.error;
          form.scrollIntoView({block:'center',behavior:'instant'});
        } finally {
          busy = false;
          form.removeAttribute('aria-busy');
          update(false);
        }
      });
      stickyButton.addEventListener('click',() => {
        update();
        if (!submit.disabled) form.requestSubmit(submit);
      });
      const observers = [];
      if ('IntersectionObserver' in window) {
        const buyObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        buyObserver.observe(submit);
        observers.push(buyObserver);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduceMotion) {
          const videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
            if (entry.isIntersecting) entry.target.play().catch(() => {});
            else entry.target.pause();
          }),{threshold:.3});
          root.querySelectorAll('video').forEach(video => videoObserver.observe(video));
          observers.push(videoObserver);
        }
      }
      root._lavelleCleanup = () => observers.forEach(observer => observer.disconnect());
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document));
  else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-lv-new-product]').forEach(root => root._lavelleCleanup?.()));
})();
